export class CardGroupModel {
  plannerGroupId: string = undefined;
  groupName: string = undefined;
  skillArea: string = undefined;
  weight: number = undefined;
  blockDescription: string = undefined;
  icon: string = undefined;
  groupType: string = undefined;
}
